import { render, staticRenderFns } from "./TeamManagerCalculationBasis.vue?vue&type=template&id=315227af&scoped=true&"
import script from "./TeamManagerCalculationBasis.vue?vue&type=script&lang=ts&"
export * from "./TeamManagerCalculationBasis.vue?vue&type=script&lang=ts&"
import style0 from "./TeamManagerCalculationBasis.vue?vue&type=style&index=0&id=315227af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315227af",
  null
  
)

export default component.exports